export default {
    async openWindow(response) {
        const base64Response = await fetch(response.data.file);
        const blob = await base64Response.blob();
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, "visualizarArquivos", "width=800,height=800");

        URL.revokeObjectURL(blobUrl);
    },

    async download(response) {
        const base64Response = await fetch(response.data.file);
        const blob = await base64Response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = response.data.name;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    },

    async downloadBlob(response) {
        const href  = URL.createObjectURL(response.data);
        const a     = document.createElement("a");

        a.href      = href;
        a.download  = response.headers.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
    },

    // (response, filename = null) => {
    //     const FILE = URL.createObjectURL(new Blob([response.data]));
    //     const download = document.createElement('a');
    //     if(!filename) {
    //         if(response.headers.filename) {
    //             filename = response.headers.filename;
    //         } else {
    //             filename = response.headers['content-disposition'].match(/filename=\"([\w\.\s]*)\"/);
    //             filename = filename[1];
    //         }
    //     }
    
    //     download.href = FILE;
    //     download.setAttribute('target', '_blank')
    //     download.setAttribute('download', filename);
    //     document.body.appendChild(download);
    //     setTimeout(() => {
    //         download.click();
    //         download.remove();
    //     }, 250)
    // }
}